<template>
  <v-sheet v-if="hasAnnotation" elevation="4" class="pa-4">
    <h3 class="text-h5">Annotation details</h3>
    <p class="body-1">
      Class:
      {{ annotationClass }}
    </p>
    <p v-if="hasDescription" class="body-1">
      {{ description }}
    </p>
    <template v-if="validationMode || !statusIsCreated">
      <p>Status: {{ $dp.mapAnnotationStatus(annotation.status) }}</p>
      <template v-if="statusIsRejected">
        <h6 class="text-h6">Reason for rejection</h6>
        <p v-if="hasRejectReason">
          {{ rejectedReason }}
        </p>
        <p v-else>No reason provided.</p>
      </template>
    </template>

    <!-- TODO display status + reject reason -->
  </v-sheet>
</template>

<script>
export default {
  props: {
    annotation: Object,
    slide: Object,
    validationMode: { type: Boolean, default: false }
  },
  computed: {
    hasAnnotation() {
      return this.annotation !== null && this.annotation !== undefined;
    },
    hasDescription() {
      return (
        this.annotation.observation !== null &&
        this.annotation.observation.note !== undefined &&
        this.annotation.observation.note.length === 1 &&
        this.annotation.observation.note[0].text.trim().length > 0
      );
    },
    description() {
      return this.annotation.observation.note[0].text.trim();
    },
    annotationClass() {
      return this.annotation.annotation_class.class_name;
    },
    statusIsRejected() {
      return this.annotation.status === "rejected";
    },
    hasRejectReason() {
      return (
        this.statusIsRejected &&
        this.annotation.rejected_reason !== null &&
        this.annotation.rejected_reason !== undefined
      );
    },
    rejectedReason() {
      return this.annotation.rejected_reason.trim();
    },
    statusIsCreated() {
      return this.annotation.status === "created";
    }
  }
};
</script>

<style scoped></style>
